import * as actions from 'actions/VipActions/activateVipAction';
import { AsyncStatus } from 'utils/asyncStatusHelper';
const defaultState = {
    asyncStatus: AsyncStatus.INIT,
    widget: []
};
const defaultTokenState = {
    asyncStatus: AsyncStatus.INIT,
    data: []
};
export function activateVip(state = defaultState, action) {
    switch (action.type) {
        case actions.ActivateVipAction.REQUEST:
            return Object.assign({}, state, {
                asyncStatus: AsyncStatus.LOADING
            });
        case actions.ActivateVipAction.SUCCESS:
            return Object.assign({}, state, {
                widget: action.data,
                asyncStatus: AsyncStatus.SUCCESS
            });
        case actions.ActivateVipAction.ERROR:
            return Object.assign({}, state, {
                asyncStatus: AsyncStatus.ERROR
            });
        case actions.ActivateVipAction.RESET:
            return Object.assign({}, state, {
                asyncStatus: AsyncStatus.INIT
            });
        default:
            return state;
    }
}
export function rewardPaymentToken(state = defaultTokenState, action) {
    switch (action.type) {
        case actions.RewardTokenAction.REQUEST:
            return Object.assign({}, state, {
                asyncStatus: AsyncStatus.LOADING
            });
        case actions.RewardTokenAction.SUCCESS:
            return Object.assign({}, state, action['data'], {
                asyncStatus: AsyncStatus.SUCCESS
            });
        case actions.RewardTokenAction.ERROR:
            return Object.assign({}, state, {
                asyncStatus: AsyncStatus.ERROR
            });
        case actions.RewardTokenAction.RESET:
            return Object.assign({}, state, {
                asyncStatus: AsyncStatus.INIT
            });
        default:
            return state;
    }
}
export function claimedReward(state = defaultState, action) {
    switch (action.type) {
        case actions.ClaimRewardAction.REQUEST:
            return Object.assign({}, state, {
                asyncStatus: AsyncStatus.LOADING
            });
        case actions.ClaimRewardAction.SUCCESS:
            return Object.assign({}, state, action['data'], {
                asyncStatus: AsyncStatus.SUCCESS
            });
        case actions.ClaimRewardAction.ERROR:
            return Object.assign({}, state, {
                asyncStatus: AsyncStatus.ERROR
            });
        case actions.ClaimRewardAction.RESET:
            return Object.assign({}, state, {
                asyncStatus: AsyncStatus.INIT
            });
        default:
            return state;
    }
}
